import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import CipHeader from "../Components/CipHeader";
import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import dSService from "../services/eom-disease-states-service";
import eomMasterService from "../services/eom-master-service";
import eomCorecivicService from "../services/eom-corecivic-formulary-service";
import MARDrugService from "../services/eom-mar-service";
import { Modal } from "react-responsive-modal";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import cogoToast from "cogo-toast";
import DOWNLOAD_ICON from "../assets/img/download.png";
import eomCensusService from "../services/eom-census-service";
import eomUnitcostService from "../services/eom-unitcost-service";
import eomPriceCodeService from "../services/eom-price-code-service";
import eomPriceMatchService from "../services/eom-price-match-service";
import eomAnyZeroesService from "../services/eom-any-zeroes-service";

const tablePropsInit = {
  columns: [
    { key: "name", title: "Name" },
    { key: "Actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "key",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 20,
    position: PagingPosition.Bottom,
  },
};
const EOMFiles = ({ history }) => {
  const names = [
    {
      key: "master",
      name: "All Facilities",
      url: "/master",
    },
    {
      key: "diseaseStates",
      name: "All Disease States",
      url: "/diseaseState",
    },
    {
      key: "corecivic",
      name: "Corecivic Formulary",
      url: "/corecivic",
    },
    {
      key: "marDrugs",
      name: "MAR",
      url: "/marDrugs",
    },
    {
      key: "census",
      name: "Census",
      url: "/census",
    },
    {
      key: "unitcost",
      name: "Unit Price",
      url: "/unitcost",
    },
    {
      key: "priceCode",
      name: "Price Code",
      url: "/priceCode",
    },
    {
      key: "priceMatch",
      name: "Price Match",
      url: "/priceMatch",
    },
    {
      key: "anyZeros",
      name: "Any Zeros",
      url: "/anyZeros",
    },
    {
      key: "Addons",
      name: "Append to EOM Data",
      url: "/eom-addons",
    },
    {
      key: "eom-update",
      name: "Update EOM Data",
      url: "/eom-update",
    },
  ];
  const [loading, setLoading] = useState(false);
  const CustomCell2 = ({ rowData }) => {
    return (
      <div
        className="text-sm cursor-pointer"
        onClick={() => handleNavigation(rowData.url)}
      >
        {rowData?.name}
      </div>
    );
  };
  const handleNavigation = async (url) => {
    try {
      await history.push(url);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error navigating tot he url. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const handleDownload = async (key) => {
    try {
      const { hide } = cogoToast.info(
        "Downloading is in progress. Please wait for sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      if (key === "master") eomMasterService.downloadDocument();
      else if (key === "diseaseStates") dSService.downloadDocument();
      else if (key === "corecivic") eomCorecivicService.downloadDocument();
      else if (key === "marDrugs") MARDrugService.downloadDocument();
      else if (key === "census") eomCensusService.downloadDocument();
      else if (key === "unitcost") eomUnitcostService.downloadDocument(month, year);
      else if (key === "priceCode") eomPriceCodeService.downloadDocument();
      else if (key === "priceMatch") eomPriceMatchService.downloadDocument();
      else if (key === "anyZeros") eomAnyZeroesService.downloadDocument();
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error downloading document. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const CustomCell = ({ rowData }) => {
    return (
      <div>
        <span className="inline-block mr-3 cursor-pointer">
          <button
            onClick={() => handleNavigation(rowData.url)}
            className={
              loading
                ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8   bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
            }
          >
            VIEW
          </button>
        </span>
        {rowData.key !== 'Addons' && rowData.key !== 'eom-update' && <span className="inline-block mr-3 cursor-pointer">
          <img
            src={DOWNLOAD_ICON}
            className="mt-1 w-6 h-6"
            alt="Download"
            title="Download"
            onClick={(e) => {
              if (rowData.key === "unitcost") {
                setDownloadOpen(true)
              } else {
                handleDownload(rowData.key);
              }

            }}
          />
        </span>}
      </div>
    );
  };

  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const dispatch1 = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      try {
        dispatch1(updateData(names));
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error retrieving data. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    }
  };
  const [downloadOpen, setDownloadOpen] = useState(false);
  const onDownloadCloseModal = () => {
    setDownloadOpen(false);
  };

  const [month, setMonth] = useState();
  const [year, setYear] = useState("2021");
  const totalMonthsList = () => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months.map((i, index) => (
      <option value={index + 1} key={i}>
        {i}
      </option>
    ));
  };

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${loading ? "show" : "hidden"
          }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <Modal open={downloadOpen} onClose={onDownloadCloseModal} center>
        <div className="pt-10 px-8 pb-4 ">
          <div className="p-2 text-xs usersList w-full gridList overflow-x-auto  ">
            <select
              name="list_month"
              aria-label="Select Month"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              className="border focus:outline-none h-10 w-1/2 rounded-md pl-2 text-sm font-normal"
            >
              <option value="0">Select Month</option>
              {totalMonthsList()}
            </select>
            <span className="ml-4">
              <select
                name="list_year"
                aria-label="Select Year"
                value={year}
                onChange={(e) => setYear(e.target.value)}
                className="border focus:outline-none h-10 rounded-md pl-2 w-1/3 text-sm font-normal  "
              >
                <option value="">Select year</option>
                <option value="2021">2021</option>
                <option value="2022">2022</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
              </select>
            </span>

          </div>
          <div className="flex justify-center">
            <button
              onClick={() => {
                handleDownload("unitcost");
                setDownloadOpen(false);
              }}
              type="button"
              className="mr-0.5 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Download
            </button>

            <button
              onClick={() => {
                setDownloadOpen(false);
              }}
              type="button"
              className="rounded font-medium h-10 text-white w-auto px-4 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Cancel
            </button>
          </div>
          {/*
           */}
        </div>
      </Modal>
      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 h-24">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">EOM Files</span>
          </div>
          <div className="w-full sm:w-1/2 text-right">
            <span>
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch1(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 h-8 mr-3 focus:outline-none focus:none pl-2"
              />
            </span>
          </div>
        </div>
        <div className="p-2 text-xs reportList gridList">
          <Table
            {...tableProps}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "Actions":
                      return <CustomCell {...props} />;
                    case "name":
                      return <CustomCell2 {...props} />;
                  }
                },
              },
            }}
            dispatch={dispatch1}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(EOMFiles)
);
